class DessonGirlDragScroll extends HTMLElement {
  constructor() {
    super();
    this.dragThreshold = 6;
    this.pointerId = null;
    this.startX = 0;
    this.startScrollLeft = 0;
    this.dragging = false;
    this.suppressClick = false;

    this.onPointerDown = this.onPointerDown.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerUp = this.onPointerUp.bind(this);
    this.onPointerCancel = this.onPointerCancel.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    if (this.initialized) return;

    this.rail = this.querySelector('.desson-girl__rail');
    if (!this.rail) return;

    this.initialized = true;
    this.rail.addEventListener('pointerdown', this.onPointerDown);
    this.rail.addEventListener('pointermove', this.onPointerMove);
    this.rail.addEventListener('pointerup', this.onPointerUp);
    this.rail.addEventListener('pointercancel', this.onPointerCancel);
    this.rail.addEventListener('click', this.onClick, true);
  }

  disconnectedCallback() {
    if (!this.rail || !this.initialized) return;

    this.rail.removeEventListener('pointerdown', this.onPointerDown);
    this.rail.removeEventListener('pointermove', this.onPointerMove);
    this.rail.removeEventListener('pointerup', this.onPointerUp);
    this.rail.removeEventListener('pointercancel', this.onPointerCancel);
    this.rail.removeEventListener('click', this.onClick, true);
    this.initialized = false;
  }

  onPointerDown(event) {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;

    this.pointerId = event.pointerId;
    this.startX = event.clientX;
    this.startScrollLeft = this.rail.scrollLeft;
    this.dragging = false;
    this.suppressClick = false;
  }

  onPointerMove(event) {
    if (event.pointerType !== 'mouse' || event.pointerId !== this.pointerId) return;

    const distance = this.startX - event.clientX;
    if (!this.dragging && Math.abs(distance) < this.dragThreshold) return;

    if (!this.dragging) {
      this.dragging = true;
      this.rail.classList.add('is-dragging');
      this.rail.setPointerCapture(event.pointerId);
    }

    event.preventDefault();
    this.rail.scrollLeft = this.startScrollLeft + distance;
  }

  onPointerUp(event) {
    if (event.pointerId !== this.pointerId) return;

    this.finishDrag(event.pointerId);
  }

  onPointerCancel(event) {
    if (event.pointerId !== this.pointerId) return;

    this.finishDrag(event.pointerId, false);
  }

  finishDrag(pointerId, shouldSuppressClick = this.dragging) {
    this.dragging = false;
    this.pointerId = null;
    this.rail.classList.remove('is-dragging');

    if (this.rail.hasPointerCapture(pointerId)) {
      this.rail.releasePointerCapture(pointerId);
    }

    if (shouldSuppressClick) {
      this.suppressClick = true;
      setTimeout(() => {
        this.suppressClick = false;
      }, 0);
    }
  }

  onClick(event) {
    if (!this.suppressClick || !event.target.closest('a')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    this.suppressClick = false;
  }
}

if (!customElements.get('desson-girl-drag-scroll')) {
  customElements.define('desson-girl-drag-scroll', DessonGirlDragScroll);
}
